
define('text!modules/targeting/location/templates/overall_header.html',[],function () { return '<div class="header-warning">\n     <div class="icon"></div>\n     <div class="text">This strategy has no location targeting applied. If you do not select any location targeting, your strategy will spend without any location restrictions.</div>\n</div>\n';});

